import type { QuoteRate } from '@/views/screens/Quote';
import CollapsiblePanel from '@views/components/Tabs/CollapsiblePanel';
import { type CollapseProps, Empty, Spin } from 'antd';
import { type FC, useState } from 'react';
import { QuoteRatePanelContent } from './quote-rate-panel-content';
import { QuoteRatePanelHeader } from './quote-rate-panel-header';

interface QuoteRateResultsProps {
  quoteRates?: QuoteRate[];
  isLoading: boolean;
}

export const QuoteRateResults: FC<QuoteRateResultsProps> = ({ quoteRates, isLoading }) => {
  const [activeKey, setActiveKey] = useState<CollapseProps['activeKey']>([]);

  const handleTabClick = (keys: CollapseProps['activeKey']) => {
    setActiveKey(keys);
  };

  if (isLoading)
    return <Spin size="large" className="w-full flex-1 d-flex justify-content-center align-items-center" />;
  if (!quoteRates || quoteRates?.length === 0)
    return (
      <Empty className="d-flex flex-1 flex-direction-column justify-content-center" description="No Results Found" />
    );

  return (
    <div className="p-24">
      <CollapsiblePanel
        handleTabClick={handleTabClick}
        // @ts-ignore
        activeKey={activeKey}
        tabs={quoteRates?.map((rate) => ({
          tabKey: `${rate.id}`,
          header: <QuoteRatePanelHeader rate={rate} />,
          content: <QuoteRatePanelContent accessorials={rate.accessorials} />,
        }))}
      />
    </div>
  );
};
